module.exports = __webpack_public_path__ + "static/media/coreforlaptop.6bae2509.png";